"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.sanitizeProps = void 0;
var sanitize_props_1 = require("./sanitize-props");
__createBinding(exports, sanitize_props_1, "default", "sanitizeProps");
//# sourceMappingURL=index.js.map